<div class="wrapper step-three">
    <div class="step-content">

        <div class="templates position-relative">
            <div class="arrows-left position-absolute">
                <img
                        (click)="scroll(target, 'left')"
                        src="./assets/imgs/Arrow-slider-left.svg"
                />
            </div>
            <div class="arrows-right position-absolute">
                <img (click)="scroll(target, 'right')" src="./assets/imgs/Arrow-slider-right.svg" />
            </div>
            <div #target class="grid">
                <button type="button" class="btn btn-outline-primary" *ngFor="let button of buttons; let i = index"
                        (click)="setEduction(i)"
                        [disabled]="buttons[i].disable"
                        [ngStyle]="{ 'background-color': buttons[i].isClickable ? '#182F7C' : 'white' }">
                    <div class="d-flex">
                        <span [ngStyle]="{ 'color': buttons[i].isClickable ? 'white' : '#182F7C' }"
                              style="color: #182F7C!important;font-size: 12px">
                    {{buttons[i].title}}</span>
                    </div>
                </button>
            </div>
        </div>
        <!-- <button
          routerLink="/design-menu/step-three"
          class="next btn bg-gold text-white mt-5"
        >
          {{ "common.next" | translate }}
        </button> -->
    </div>
</div>
